import React, { useMemo, memo, useState, useEffect } from "react";
import PT from "prop-types";
import * as S from "./styled";
import PlusIcon from "_c/icon/Plus";
import {
  DEFAULT_PROFILE_PHOTO,
  DEFAULT_PROFILE_PHOTO_MALE,
  DEFAULT_PROFILE_PHOTO_DARK,
  DEFAULT_PROFILE_PHOTO_MALE_DARK,
  DEFAULT_SALOON_LOGO,
} from "@/misc/constants";
import { generateUrl } from "@/utils/cloudinary";
import { useCloudinaryWidget } from "@/hooks/useCloudinaryWidget";
import { useNotify } from "@/hooks/useNotify";
import { CircleButton } from "_c/button";
import CloseableMessage from "_c/CloseableMessage";
import { useTheme } from "@/hooks/useTheme";
import { analyticsAction } from "@/utils/analytics";

const Tip = ({ t }) => {
  return null;
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const timeout = setTimeout(() => {
      setVisible(true);
    }, 1);
    return () => clearTimeout(timeout);
  }, []);
  if (!visible) return null;
  return (
    <CloseableMessage
      message={t(`master_profile:ava_advice`)}
      name="master_set_ava_tip"
      css={`
        position: absolute;
        bottom: 0;
        left: 5%;
        width: 90%;
      `}
    />
  );
};
const Avatar = ({ t, ...props }) => {
  const { uploadPhoto } = useCloudinaryWidget();
  const theme = useTheme();
  const { notify, notifyError } = useNotify();
  const onClick = async () => {
    const photo = await uploadPhoto();
    if (props.pageType === "saloon") {
      analyticsAction({
        category: "salon_profile",
        action: "salon_add_avatar",
      });
    }
    try {
      notify(t("common:avatar_load_success"));
      await props.updateAvatar(photo);
    } catch (e) {
      notifyError(t([`errors:${e}`, "errors:unspecified_server"]));
    }
  };
  const url = useMemo(() => {
    if (props.avatar) {
      return generateUrl(props.avatar, {
        width: 720,
        height: 800,
        crop: "fill",
        gravity: "face",
      });
    } else if (props.pageType === "saloon") {
      return DEFAULT_SALOON_LOGO;
    } else {
      const isDark = theme.__name__ === "dark";
      if (props.sex) {
        if (isDark) {
          return DEFAULT_PROFILE_PHOTO_MALE_DARK;
        } else {
          return DEFAULT_PROFILE_PHOTO_MALE;
        }
      } else {
        if (isDark) {
          return DEFAULT_PROFILE_PHOTO_DARK;
        } else {
          return DEFAULT_PROFILE_PHOTO;
        }
      }
    }
  });
  return (
    <S.Wrap>
      <S.Pic alt={props.altText} src={url} />
      {props.isOwner && (
        <>
          <S.UploadButtonContainer>
            <CircleButton title={t("common:avatar_load_tip")} onClick={onClick}>
              <PlusIcon color="white" />
            </CircleButton>
          </S.UploadButtonContainer>
          {props.pageType === "master" && !props.avatar && <Tip t={t} />}
        </>
      )}
    </S.Wrap>
  );
};
Avatar.propTypes = {
  avatar: PT.string,
  sex: PT.bool,
  isOwner: PT.bool.isRequired,
  pageType: PT.oneOf(["client", "master", "saloon"]).isRequired,
  altText: PT.string,

  t: PT.func.isRequired,
  updateAvatar: PT.func.isRequired,
};

export default memo(Avatar);
